<template>
  <div class="width-full" style="background: #0A0D2C;padding: 2rem 0 1rem 0;">
    <div class="max-width mauto">
      <div class="flex flex-col align-center mauto color-white">
        <div class="fs-18 font-bold">{{ info.name }}</div>
        <div class="flex flex-between fs-14 width-full" style="padding: 1.5rem ;">
          <div class="flex align-center">
            <img src="../assets/phone.png" alt="" style="width: 1.2rem;height: 1.2rem;">
            <span style="opacity: 0.8;padding-left: 0.5rem;">电话：{{ info.mobile }}</span>
          </div>
          <div class="flex align-center">
            <img src="../assets/email.png" alt="" style="width: 1.2rem;height: 1.2rem;">
            <span style="opacity: 0.8;padding-left: 0.5rem;">邮箱：{{ info.emaile }}</span>
          </div>
          <div class="flex align-center">
            <img src="../assets/address.png" alt="" style="width: 1.2rem;height: 1.2rem;">
            <span style="opacity: 0.8;padding-left: 0.5rem;">地址：{{ info.address }}</span>
          </div>
        </div>
        <div class="fs12" style="padding-top: 2rem;opacity: 0.8;">Copyright Ⓒ2025 山西信达农林工程咨询有限公司版权所有  <span class="pointer" @click="jump1" style="padding-left: 1rem;">{{ info.beian }}</span>  <span class="pointer" style="padding-left: 1rem;" @click="jump2">技术支持：科辉荣盛</span></div>
      </div>
    </div>
    
  </div>
</template>
   
<script>
import { index } from "../api/home";

export default {
	data() {
		return {
      info:''
		}
	},

  created(){
    this.getNewImg()
    
    
  },
  methods: {
   getNewImg() {
      index().then((res) => {
        if (res.code == 1) {
          this.info = res.data
        }
      });
    },
    jump1(){
      window.location.href = 'https://beian.miit.gov.cn/'
    },
    jump2(){
      window.location.href = 'http://www.bjkhrs.com/'
    }
  },
}
</script>

<style scoped lang="scss">

</style>